var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"tw-w-full tw-text-center"},'div',_vm.$attrs,false),[_c('div',{staticClass:"no-dealers-found__msg tw-pt-2 tw-pb-2"},[_vm._v("\n    "+_vm._s(_vm.message || _vm.$t('no results found'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }